export default {
    inserted(el) {
        setTimeout(()=>el.focus(), 0);
    }
}